import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
const AnnounceFromPayload = ({ node, extraData, text, }) => {
    var _a;
    const { payload: { announcement } = { announcement: null } } = node;
    let label = 'None';
    let url = '';
    if (announcement === null || announcement === void 0 ? void 0 : announcement.file) {
        label = announcement.file.label;
        url = announcement.file.url;
    }
    if (!label && url) {
        if (extraData.announcements) {
            const xAnnouncement = extraData.announcements.find((ann) => ann.url === url);
            if (xAnnouncement && xAnnouncement.pretty_name) {
                label = xAnnouncement.pretty_name;
            }
        }
    }
    if (!label) {
        label = ((_a = /([^/]+$)/.exec(url)) === null || _a === void 0 ? void 0 : _a.toString()) || 'None';
    }
    const nodeText = text || 'Announcement';
    return (_jsxs("div", Object.assign({ style: {
            height: '16px',
            maxWidth: '100%',
            WebkitLineClamp: 1,
            WebkitBoxOrient: 'vertical',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        } }, { children: [nodeText, " ", _jsx("strong", { children: label })] })));
};
export default memo(AnnounceFromPayload);
